<div class="container-fluid">
    <div class="container">
        <div class="headings">
            <span class="hr"></span>
            <h1>Add New Location</h1>
            <span class="hr"></span>
        </div>
            <div class="row">
            <div class="col-md-6">
                <form #f=ngForm>
                    <div class="form-group">
                        <label for="title">Title</label>
                        <input type="text" [(ngModel)]="loc.name" name="title" #title="ngModel" id="title" class="form-control" required minlength="4">
                        <div class="alert alert-danger" *ngIf="title.touched && title.invalid">
                            <div>Please enter valid title</div>
                        </div>
                    </div>
        
                    <div class="form-group">
                        <label for="title">Description</label>
                        <textarea [(ngModel)]="loc.description" name="description" rows="5" #description="ngModel" id="description" class="form-control" required minlength="50"></textarea>
                        <div class="alert alert-danger" *ngIf="description.touched && description.invalid">
                            <div>Please enter valid discription</div>
                        </div>
                    </div>
    
                    <div class="form-group">
                        <label for="category">Category</label>
                        <select id="category" class="form-control"  #category="ngModel"  name="category" (ngModelChange)="onChangeCat($event)" [(ngModel)]="selectedCatg" required >
                           <option *ngFor="let catg of cat" [value]="catg.id" >{{catg.name}}</option >
                        </select>
                        <div class="alert alert-danger" *ngIf="category.touched && category.invalid">
                            <div>Please select a category</div>
                        </div>
                    </div>
    
                    <div class="form-group">
                        <label for="governorat">Governorat</label>
                        <select id="governorat" class="form-control" #governorat="ngModel"  name="governorat" (ngModelChange)="onChangeGav($event)" [(ngModel)]="selectedGov"
                        required >
                           <option *ngFor="let governorat of gav"  [value]="governorat.id">{{governorat.name}} </option>
                        </select>
                        <div class="alert alert-danger"  *ngIf="governorat.touched && governorat.invalid">
                            <div>Please select a governorate</div>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom:15px;">
                        <div class="col-md-3">
                          <input multiple type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" style="display:none;">
                          <button type="button" class="btn btn-success" (click)="file.click()">Upload File</button>
                        </div>
                        <div class="col-md-4">
                          <span class="upload" *ngIf="progress > 0">
                            {{progress}}%
                          </span>
                          <span class="upload" *ngIf="message">
                            {{message}}
                          </span>
                        </div>
                      </div>
                   
                </form>
                <button class="btn btn-success" [disabled]="f.invalid" (click)="create()"> Add location </button>
    
            </div>
    
          
    </div>
    </div>

</div>